import { createSelector } from "reselect";

export const getAllSubscriptionPlans = (state) => state.subscriptionPlan.plans;

const getAllSubscriptionPlansNames = (state) => state.subscriptionPlan.plansNames;

export const isMonthly = (state) => state.subscriptionPlan.isMonthly;
export const isSelectedAnnuallyFromPicker = (state) => state.subscriptionPlan.isSelectedAnnuallyFromPicker;

const getSubscriptionPlanByName = (state, planName) => {
  return getAllSubscriptionPlans(state) && getAllSubscriptionPlans(state).get(`${planName}`);
};

export const getSubscriptionPlanByNameSelector = createSelector(
  [getSubscriptionPlanByName],
  (plan) => plan && plan.toJS()
);

export const getAllSubscriptionPlansValues = createSelector(
  [getAllSubscriptionPlans],
  (plans) => plans && plans.valueSeq().toArray()
);

export const getAllSubscriptionPlansNamesSelector = createSelector(
  [getAllSubscriptionPlansNames],
  (plansNames) => plansNames && plansNames.toJS()
);
